<template>
  <li @click="handleDisabled">
    <button
      ref="button"
      :class="[{ current: isCurrent }, props.phase]"
      :data-phase="props.phase"
      :title="props.title"
      :disabled="isDisabled"
      @click="handleClick"
      @keyup.space="(e) => e.preventDefault()"
    >
      <app-icon :icon="props.phase" class="phaseIcon" />
      <span class="text"><slot /></span>
    </button>
    <slot name="tips" />
  </li>
</template>

<script setup>
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { usePhaseStore } from '@/store/pinia/phase';
import { useUsersStore } from '@/store/pinia/users';
import { useUiAnimations } from '@/composables/useUiAnimations';
import AppIcon from '@/components/AppIcon.vue';

const { nopeWaggle } = useUiAnimations();
const props = defineProps({
  phase: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
});
const emit = defineEmits(['navigate', 'nope']);
const phaseStore = usePhaseStore();
const usersStore = useUsersStore();
const button = ref(null);

const { usersHere, usersStillAwayInGroup } = storeToRefs(usersStore);
const { currentPhase, rawCurrentPhase, settingUp } = storeToRefs(phaseStore);

const isCurrent = computed(() => currentPhase.value === props.phase);
const isDisabled = computed(() => {
  if (notEnough.value) {
    return true;
  } else if (['freeform', 'init', 'lobby'].includes(rawCurrentPhase.value) && !settingUp.value) {
    return false;
  } else {
    return currentPhase.value !== props.phase;
  }
});
const notEnough = computed(() => props.phase === 'groups' && (usersHere.value.length < 4 || usersStillAwayInGroup.value.length));

function handleClick() {
  if (notEnough.value) {
    emit('nope', 'notEnough');
  } else {
    emit('navigate', props.phase);
  }
}

function handleDisabled() {
  if (notEnough.value) {
    nopeWaggle(button.value);
    if (notEnough.value) {
      emit('nope', 'notEnough');
    }
  }
}
</script>
<style lang="scss" scoped>
li {
  display: flex;
  width: rem(83px);
  height: rem(83px);
  margin: 0 1em rem(22px + 18px) 1em;
  position: relative;
}

button {
  margin: 0 auto;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border: none;
  padding: 0;
  @include triggered {
    color: var(--c__text);
    background: transparent;
  }
}

:deep(.phaseIcon) {
  margin-bottom: rem(7px);
  position: relative;
  display: block;
}

.text {
  position: relative;
  margin: 0 -1em;
}

button:disabled .phaseIcon {
  color: var(--c__disabled);
  background: var(--c__bg);
}

button:disabled {
  color: var(--c__disabled);
  pointer-events: none;
}
</style>
